import Section from '../../../elements/Section'
import Container from '../../../elements/Container'
import Grid from '../../../elements/Grid'
import styles from './styles.module.scss'
import StaffVertical from '../../../custom/StaffVertical'
import { useResponsive } from '../../../../providers/ResponsiveContext'

const Professionals = ({ label, title, staff }) => {
  const { isDesktop, isSmallMobile } = useResponsive()

  if (staff && title) {
    return (
      <Section separator variant={['center', 'separator-top']}>
        <Container variant={[isDesktop ? '-xs2' : '-xl2']}>
          {label && <div className={styles.label}>{label}</div>}

          {title && <h2 className={styles.title}>{title}</h2>}

          {staff && (
            <div className={styles.content}>
              <Grid
                variant={[
                  isSmallMobile ? 'grid-1' : isDesktop ? 'grid-2' : 'grid-4',
                  'spacing-xl'
                ]}
              >
                {staff.map((item, index) => (
                  <StaffVertical
                    sizes="(min-width: 1250px) 310px, (max-width: 1250px) 300vw, 70vw"
                    key={`staff-${index}`}
                    {...item}
                  />
                ))}
              </Grid>
            </div>
          )}
        </Container>
      </Section>
    )
  }

  return
}

export default Professionals
